import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError, API_BASE } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Download } from "lucide-react";

export default function Account() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [current, setCurrent] = useState(""); const [pw, setPw] = useState(""); const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Passwords don't match");
    try { await api.post("/auth/change-password", { current_password: current, new_password: pw }); toast.success("Password updated"); setCurrent(""); setPw(""); setPw2(""); }
    catch (err) { toast.error(apiError(err)); }
  };
  const doLogout = async () => { await logout(); nav("/login"); };
  const downloadBackup = async () => {
    setBusy(true);
    try {
      const res = await api.post("/backup/download", null, { responseType: "blob" });
      const stamp = new Date().toISOString().replace(/[:.]/g, "-").slice(0, 19);
      const url = URL.createObjectURL(res.data); const a = document.createElement("a");
      a.href = url; a.download = `plutus_backup_${stamp}.tar.gz`; a.click();
      toast.success("Backup downloaded");
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return <div className="space-y-6 max-w-lg" data-testid="account-page">
    <div><div className="overline">Owner</div><h1 className="font-serif text-4xl mt-1">Account</h1>
      <p className="text-sm text-muted-foreground mt-1">Signed in as <b className="gold">{user?.username}</b></p></div>
    <form onSubmit={submit} className="space-y-4 border rounded-md p-6">
      <h2 className="font-serif text-2xl">Change Password</h2>
      <div><Label>Current Password</Label><Input type="password" value={current} onChange={e => setCurrent(e.target.value)} data-testid="pw-current" /></div>
      <div><Label>New Password</Label><Input type="password" value={pw} onChange={e => setPw(e.target.value)} data-testid="pw-new" /></div>
      <div><Label>Confirm New Password</Label><Input type="password" value={pw2} onChange={e => setPw2(e.target.value)} data-testid="pw-confirm" /></div>
      <Button type="submit" className="gold-bg" data-testid="pw-submit">Update Password</Button>
    </form>
    <div className="border rounded-md p-6 space-y-3">
      <h2 className="font-serif text-2xl">Database Backup</h2>
      <p className="text-sm text-muted-foreground">Download the latest database snapshot on demand as a .tar.gz. The pod also keeps a daily local backup for safety.</p>
      <Button className="gold-bg" onClick={downloadBackup} disabled={busy} data-testid="backup-download-btn"><Download className="w-4 h-4 mr-2" />{busy ? "Preparing…" : "Backup now & download"}</Button>
    </div>
    <div className="border rounded-md p-6"><h2 className="font-serif text-2xl">Session</h2>
      <Button variant="outline" onClick={doLogout} className="mt-3" data-testid="account-logout">Sign out</Button></div>
  </div>;
}
